// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"7b499caa","202":"c3813c02","221":"b6398a7f","227":"2b991acf","264":"9b7f228f","432":"0176b5f1","479":"689d30db","620":"43a16c82","933":"52d43b1b"}[chunkId] + ".chunk.js";
};